module.exports = __webpack_public_path__ + "static/media/passport status .2dc04f46.svg";